import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { IProduction } from '../../../../models/production.model';
import { ISharedDataState } from '../../../../services/facades/master-data/shared-data-state.model';
import { SharedDataFacade } from '../../../../services/facades/master-data/shared-data.facade';

@Component({
    selector: 'app-production-table',
    templateUrl: './production-table.component.html',
    styleUrls: [ './production-table.component.scss' ],
})
export class ProductionTableComponent implements OnInit {

    @Input()
    public set productions(productions: IProduction[]) {
        this.datasource.data = productions;
    }

    @Input()
    public tableColumns: string[];


    public sharedDataState$: Observable<ISharedDataState>;
    public datasource: MatTableDataSource<IProduction> = new MatTableDataSource<IProduction>([]);

    constructor(private mySharedDataFacade: SharedDataFacade) {
    }

    public ngOnInit(): void {
        this.sharedDataState$ = this.mySharedDataFacade.subState();
    }

}
